var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tabs",
    { staticClass: "search-results-tabs", on: { changed: _vm.tabChanged } },
    [
      _c("tab", {
        staticClass: "search-results-tabs__tab strong-medium",
        attrs: { title: "PRODUCTS" }
      }),
      _c("tab", {
        staticClass: "search-results-tabs__tab strong-medium",
        attrs: { title: "ARTICLES" }
      }),
      _c("tab", {
        staticClass: "search-results-tabs__tab strong-medium",
        attrs: { title: "PAGES" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }